import React from "react";
import {useTranslation} from "react-i18next";
import {SelectField} from "./FilterComponentStyles";
import {useObserver} from "mobx-react-lite";
import {arrayAlphabeticalSort} from "../../../utils/helpers";
import {courierTypes, userTypes} from "../../../constants/constants";
const CourierTypeFilter = ({
    allKey = "all",
    allowClear = false,
    hideTitle = false,
    showAll = true,
    showSearch = true,
    filterOnly = [...courierTypes.map(type => type?.value)],
    ...props
}) => {
    const {t} = useTranslation(["userTypes"]);

    return useObserver(() => (
        <React.Fragment>
            {!hideTitle && <h5>{t("fields.courierType", {ns: "common"})}</h5>}
            <SelectField
                allowClear={allowClear}
                showSearch={showSearch}
                filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                    option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                data-testid="userTypeSelect"
                {...props}
            >
                {showAll && (
                    <SelectField.Option value={allKey} data-testid="courierTypeSelect_option">
                        {t("filters.all", {ns: "common"})}
                    </SelectField.Option>
                )}

                {arrayAlphabeticalSort(
                    [...courierTypes?.filter(type => [...filterOnly].includes(type.value))],
                    "value"
                ).map(courierType => (
                    <SelectField.Option
                        key={courierType.value}
                        value={courierType.value}
                        data-testid="courierTypeSelect_option"
                    >
                        {t(courierType.translation_key, {ns: "courierTypes"})}
                    </SelectField.Option>
                ))}
            </SelectField>
        </React.Fragment>
    ));
};

export default CourierTypeFilter;
